<template>
  <div class="login-container">
    <el-form 
      autoComplete="on" 
      :model="loginForm"  
      size='default' 
      :rules="loginRules" 
      ref="loginForm" 
      class="card-box login-form">
      
      <h3 class="title">{{$store.state.sys.title}}</h3>
      <el-form-item prop="username">
        <el-input name="username"   type="text" v-model.trim="loginForm.username" autoComplete="on" placeholder="登录用户名" />
      </el-form-item>
      <el-form-item prop="password">
        <el-input name="password"  :type="pwdType" @keyup.enter.native="handleLogin" v-model="loginForm.password" autoComplete="on"
          placeholder="登录密码"></el-input>
      </el-form-item>
      <el-form-item class="btn">
          <el-button class="btn-login" type="primary" :loading="loading" @click.native.prevent="handleLogin">登录</el-button>
      </el-form-item>
    </el-form>
    <div class="foot_copy" v-html="$store.state.sys.company"></div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'login',
  data() {
    return {      
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, trigger: 'blur', message:'请输入用户名' },
          { min: 4, max: 11, message: '用户名长度在 4 到 12 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, trigger: 'blur', message:'请输入密码' },
          { min: 6, max: 16, message: '密码长度在 6 到 16 个字符', trigger: 'blur' }
        ]
      },
      loading: false,
      redirect: undefined,
      pwdType: 'password',
      isLogin: 0,
      ticket: ''
    }
  },
  async created(){
    let isLogin=this.$route.query.isLogin;
    let ticket=this.$route.query.ticket;
    let user=this.$route.query.user;
    this.redirect=this.$route.query.redirect;
    if(ticket){
      if (typeof(ticket) == 'object') {
        this.ticket = ticket[0]
      } else {
        this.ticket = ticket
      }
      await this.getTicketState()
    }
    if(isLogin) {
      if(!user){
        this.$message.error('免密登录需要user参数！');
        return
      }
      this.isLogin = isLogin
      this.noLogin()
    }
  },
  methods: {
    showPwd() {
      if (this.pwdType === 'password') {
        this.pwdType = ''
      } else {
        this.pwdType = 'password'
      }
    },
    noLogin() {
      let noLoginData = {
        username: this.$route.query.user,
        password: 'a12345678'
      }
      this.loading = true
      this.$store.dispatch('login', noLoginData).then((res) => {
        this.loading = false
        if(res.code==1000){
          if(this.redirect&&this.redirect!=undefined){
            this.$router.push({ path: this.redirect || '/index' })
          }else{
            this.$router.push({ path: '/index' })
          }
        }else{
          return this.$message({
            message: res.message || '错误',
            type: 'error',
            duration: 3 * 1000
          });
          
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('login', this.loginForm).then((res) => {
            this.loading = false
            if(res.code==1000){
              if(this.redirect&&this.redirect!=undefined){
                this.$router.push({ path: this.redirect || '/index' })
              }else{
                this.$router.push({ path: '/index' })
              }
            }else{
              return this.$message({
                message: res.message || '错误',
                type: 'error',
                duration: 3 * 1000
              });
            }
          }).catch(() => {
            this.loading = false
          })
        } else {
          return false
        }
      })
    },
    async getTicketState() {
      const signUrl = 'https://light.taiott.com/v1/tuya/consumeTickets?ticket='+this.ticket;
      await axios.get(signUrl).then((res) => {
        // console.log('getTicketState',res)
        if (!res.data || res.data.code!=200) {
          return this.$message.error(`fetch failed: ${res.data.msg}`);
        }
        let resData = res.data.data
        if(!resData || !resData.success) {
          return this.$message.error(`fetch failed: ${resData.msg}`);
        }
        this.ticketLogin()
      })
    },
    ticketLogin() {
      let noLoginData = {
        username: 'HZZYJ',
        password: 'a12345678'
      }
      this.loading = true
      this.$store.dispatch('login', noLoginData).then((res) => {
        if(this.redirect&&this.redirect!=undefined){
          this.$router.push({ path: this.redirect || '/index' })
        }else{
          this.$router.push({ path: '/index' })
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="less">
  @dark_gray:#889aa4;
  @light_gray:#eee;
  @active:#1de7ff;
  .login-container {
    position: fixed;
    height: 100%;
    width:100%;
    background:url('../assets/home_images/loginbg.jpg') no-repeat;
    background-size: cover;
    left:0;
    top:0;
    right:0;
    bottom:0;
    display: flex;
    align-items: center;
    justify-content: center;
    input {
      -webkit-appearance: none;
      height: 46px;
    }
    .el-input__inner{
      color:#111 !important
    }
    .el-input__inner::placeholder{
      color:#aaa !important
    }
    


    .login-form {
      border-radius: 5px;
      background-clip: padding-box;
      width: 350px;
      margin: 0 auto;
      padding: 20px 40px;
      background-color: hsla(0,0%,100%,1);
      border: 1px solid #fff;
    }
    .title {
      margin: 16px auto 25px;
      text-align: center;
      font-size: 24px;
      color: #505458;
    }
    .btn {
      text-align: center;
    }
    .btn-login {
      width: 100%;
      padding: 15px 20px;
      background-color: #595959 !important;
      border-color: #595959 !important;
      height: auto !important;
      font-size: 16px !important;
    }
    .foot_copy{
      width:100%;
      height:30px;
      bottom: 10px;
      color: #fff;
      text-align: center;
      position: absolute;
      z-index: 999;  
      left:0;
      font-size:14px;
    }
    .foot_copy a{
      color:#fff;
      font-weight: bold;
      display:inline-block;
      background: @active;
    }
    .el-form-item__content{
      height:auto;
    }
  }
</style>
